
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SurveyRuleConditionValidationError {
  export enum SurveyRuleConditionValidationError {
    EXACT_ONE_CONDITION_MUST_HAVE_NONE_CONNECTOR = "EXACT_ONE_CONDITION_MUST_HAVE_NONE_CONNECTOR",
    INVALID_QUESTION_KEY = "INVALID_QUESTION_KEY",
    INVALID_QUESTION_TYPE = "INVALID_QUESTION_TYPE",
    INVALID_QUESTION_KEY_GROUP_CHILD = "INVALID_QUESTION_KEY_GROUP_CHILD",
    INVALID_OPTION_CODE_VALUE = "INVALID_OPTION_CODE_VALUE",
    INVALID_RESPONDENT_KEY = "INVALID_RESPONDENT_KEY",
    INVALID_RESPONDENT_VALUE = "INVALID_RESPONDENT_VALUE",
  }

  export interface SurveyRuleConditionValidationErrorDTO {
    case: string;
  }

  export const fromDTO = (dto: SurveyRuleConditionValidationErrorDTO): SurveyRuleConditionValidationError => {
    if (dto === undefined || dto === null) {
      throw new InvalidSurveyRuleConditionValidationErrorError(
        `Invalid DTO ${dto} provided for SurveyRuleConditionValidationError.SurveyRuleConditionValidationError`
      );
    }
    switch (dto.case) {
      case "EXACT_ONE_CONDITION_MUST_HAVE_NONE_CONNECTOR":
        return SurveyRuleConditionValidationError.EXACT_ONE_CONDITION_MUST_HAVE_NONE_CONNECTOR;
      case "INVALID_QUESTION_KEY":
        return SurveyRuleConditionValidationError.INVALID_QUESTION_KEY;
      case "INVALID_QUESTION_TYPE":
        return SurveyRuleConditionValidationError.INVALID_QUESTION_TYPE;
      case "INVALID_QUESTION_KEY_GROUP_CHILD":
        return SurveyRuleConditionValidationError.INVALID_QUESTION_KEY_GROUP_CHILD;
      case "INVALID_OPTION_CODE_VALUE":
        return SurveyRuleConditionValidationError.INVALID_OPTION_CODE_VALUE;
      case "INVALID_RESPONDENT_KEY":
        return SurveyRuleConditionValidationError.INVALID_RESPONDENT_KEY;
      case "INVALID_RESPONDENT_VALUE":
        return SurveyRuleConditionValidationError.INVALID_RESPONDENT_VALUE;
      default:
        throw new InvalidSurveyRuleConditionValidationErrorError(
          `Case ${dto.case} is not valid case of SurveyRuleConditionValidationError.SurveyRuleConditionValidationError`
        );
    }
  };

  export const toDTO = (surveyRuleConditionValidationError: SurveyRuleConditionValidationError): SurveyRuleConditionValidationErrorDTO => {
    const enumDTO = {
      case: SurveyRuleConditionValidationError[surveyRuleConditionValidationError],
    };
    return enumDTO;
  };
}

export class InvalidSurveyRuleConditionValidationErrorError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorError";
  }
}
export class InvalidSurveyRuleConditionValidationErrorExactOneConditionMustHaveNoneConnectorError extends InvalidSurveyRuleConditionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorExactOneConditionMustHaveNoneConnectorError";
  }
}

export class InvalidSurveyRuleConditionValidationErrorInvalidQuestionKeyError extends InvalidSurveyRuleConditionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorInvalidQuestionKeyError";
  }
}

export class InvalidSurveyRuleConditionValidationErrorInvalidQuestionTypeError extends InvalidSurveyRuleConditionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorInvalidQuestionTypeError";
  }
}

export class InvalidSurveyRuleConditionValidationErrorInvalidQuestionKeyGroupChildError extends InvalidSurveyRuleConditionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorInvalidQuestionKeyGroupChildError";
  }
}

export class InvalidSurveyRuleConditionValidationErrorInvalidOptionCodeValueError extends InvalidSurveyRuleConditionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorInvalidOptionCodeValueError";
  }
}

export class InvalidSurveyRuleConditionValidationErrorInvalidRespondentKeyError extends InvalidSurveyRuleConditionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorInvalidRespondentKeyError";
  }
}

export class InvalidSurveyRuleConditionValidationErrorInvalidRespondentValueError extends InvalidSurveyRuleConditionValidationErrorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleConditionValidationErrorInvalidRespondentValueError";
  }
}
